import { Dropzone } from '@grupoa/editor-html';
import Editor from '@/components/content-management/editor-container';
import { format } from 'date-fns';
import { verifyContentOfEditorIsEmpty } from '~/helpers/stringHelper';

const DEFAULT_LOCALE_DATE_FORMAT = 'dd/MM/yyyy HH:mm';

export default {
  props      : ['content', 'hover', 'title'],
  components : {
    Editor,
    Dropzone
  },
  data() {
    return {
      initialContent : '',
      config         : {
        customHeight  : 300,
        isInline      : false,
        customToolbar : 'undo redo | formatselect | fontsizeselect | bold italic forecolor fontselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent hr removeformat | customLink grupoaAttachment grupoaBook grupoaLayout grupoaInteractive grupoaAudio grupoaVideo recordVideo recordAudio | wirisMathType wirisChemType '
      }
    };
  },
  mounted() {
    this.contentData = this.content;
  },
  computed: {
    init() {
      return {
        config: {
          autoFocus : true,
          isInline  : true
        }
      };
    },
    computedDateTime() {
      if (!this.content.expectedAnswerAt) {
        return '';
      }

      return format(new Date(this.content.expectedAnswerAt), DEFAULT_LOCALE_DATE_FORMAT);
    }
  },
  methods: {
    emitBlur(value) {
      if (this.initialContent !== this.content) {
        this.$emit('blur', value);
      }
    },
    blurHtml(value) {
      if (verifyContentOfEditorIsEmpty(value)) {
        this.$toast.error(this.$t('taskEditor.requiredHtml'));
      };

      this.$emit('blur', { html: value });
    },
    blurExpectedAnswer(value) {
      if (verifyContentOfEditorIsEmpty(value)) {
        this.$toast.error(this.$t('taskEditor.requiredExpectedAnswer'));
      };

      this.$emit('blur', { expectedAnswer: value });
    }
  }
};
